<template>
  <div class="page">
    <div class="muted">{{ $t('common.loading') }}</div>
  </div>
</template>

<script>
import { handlerCaseDetail } from '../../api/tickets';

export default {
  name: 'HandlerCaseDetailRoute',
  async created() {
    const caseNo = this.$route.params.caseNo ? String(this.$route.params.caseNo) : '';
    if (!caseNo) return this.$router.replace('/handler/in-progress');
    try {
      const d = await handlerCaseDetail(caseNo);
      const st = d && d.status ? String(d.status) : '';
      if (st === 'PENDING' || st === 'ESCALATED') return this.$router.replace({ path: '/handler/pool', query: { caseNo } });
      if (st === 'IN_PROGRESS') return this.$router.replace({ path: '/handler/in-progress', query: { caseNo } });
      if (st === 'CLOSED') return this.$router.replace({ path: '/handler/closed', query: { caseNo } });
      return this.$router.replace({ path: '/handler/in-progress', query: { caseNo } });
    } catch (e) {
      return this.$router.replace({ path: '/handler/in-progress', query: { caseNo } });
    }
  }
};
</script>
